<template>
	<div class="fund_manage">
		<!--    <a-tabs defaultActiveKey="1" @change="handCut">-->
		<!--      <a-tabs :defaultActiveKey="activeKey" @change="handCut">-->
		<a-tabs :activeKey="activeKey" @change="handCut">
			<span slot="tabBarExtraContent">
				<a-button   type="primary" class="freight" @click="onConfig">运费模板管理</a-button>
			</span>
			<a-tab-pane tab="商品列表" key="1" v-if="commodity_setup[0]">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline">
						<a-form-item>
							<a-cascader
								v-if="options.length"
								style="width: 195px"
								:fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
								:options="options"
								v-model="cid1"
								@change="onChange"
								:displayRender="displayRender"
								changeOnSelect
								:loadData="loadData"
								placeholder="请选择商品分类"
							/>
							<a-select v-else placeholder="请选择商品分类" style="width: 195px"></a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品品牌" style="width: 195px" v-model="brand_id1">
								<a-select-option v-for="(item, i) in brandlist" :key="i" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品状态" style="width: 195px" v-model="status1">
								<a-select-option v-for="(item, i) in select" :key="i" :value="item.value">{{ item.text }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item><a-input allowClear style="width:300px;" placeholder="请输入商品名称" v-model="product_title1" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="initGoods">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle">
					<a-button type="primary" @click="onNavJump('goodsmanage/add?commodity_type=0')">发布商品</a-button>
					<a-button @click="putawayAll('up')">批量上架</a-button>
					<a-button @click="putawayAll('down')">批量下架</a-button>
					<a-button @click="deletePro('all')">批量删除</a-button>
					<a-button @click="importFile(0)">批量导入</a-button>
					<a-button @click="exportAttr">批量导出属性</a-button>
					<a-button @click="download">批量导出</a-button>
				</div>

				<!-- 表格  :pagination="{pageSize:5,total: total1}"-->
				<div id="tabHeight1" style="flex: 1;">
					<a-table
					    v-if="tabHeight>0"
						:loading="loading"
						:rowSelection="{ selectedRowKeys: selectedRowKeysA, onChange: onSelectChangeA }"
						:columns="columns"
						:dataSource="dataSource"
						:pagination="pagination"
						@change="onChangeload"
						:scroll="{ x: 1700, y: tabHeight }"
					>
						<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
						
						<div slot="product_title" class="proTitleDiv" slot-scope="text" :title="text">
							{{text}}
						</div>
					
						<span slot="status" slot-scope="text">
							<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
							<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
							<a-tag v-else color="#969DA8">待上架</a-tag>
						</span>
					
						<span slot="action" slot-scope="text">
							<div>
								<template v-if="text.status == 2">
									<a
										@click="seeProduct(text.id,text.commodity_type)"
									>详情</a>
									<a-divider type="vertical" />
									<a
										@click="putaway(text.id, 'dowm')"
									>下架</a>
								</template>
								<template v-else>
									<a
										@click="onexits(text.id,text.commodity_type)"
									>编辑</a>
									<a-divider type="vertical" />
									<a
										@click="putaway(text.id, 'up')"
									>上架</a>
								</template>
								
								<a-divider type="vertical" />
								<a
									@click="repertoryAdd(text.id)"
								>添加库存</a>
								<a-divider type="vertical" />
								<a
									@click="deletePro('single', text.id)"
								>删除</a>
							</div>
						</span>
					</a-table>
				</div>
				
			</a-tab-pane>
			
			<a-tab-pane tab="服务类商品" key="4" v-if="commodity_setup[0]">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline">
						<a-form-item>
							<a-cascader
								v-if="options.length"
								style="width: 195px"
								:fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
								:options="options"
								v-model="cid1"
								@change="onChange"
								:displayRender="displayRender"
								changeOnSelect
								:loadData="loadData"
								placeholder="请选择商品分类"
							/>
							<a-select v-else placeholder="请选择商品分类" style="width: 195px"></a-select>
						</a-form-item>
			
						<a-form-item>
							<a-select allowClear placeholder="请选择商品品牌" style="width: 195px" v-model="brand_id1">
								<a-select-option v-for="(item, i) in brandlist" :key="i" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
							</a-select>
						</a-form-item>
			
						<a-form-item>
							<a-select allowClear placeholder="请选择商品状态" style="width: 195px" v-model="status1">
								<a-select-option v-for="(item, i) in select" :key="i" :value="item.value">{{ item.text }}</a-select-option>
							</a-select>
						</a-form-item>
			
						<a-form-item><a-input allowClear style="width:300px;" placeholder="请输入商品名称" v-model="product_title1" /></a-form-item>
			
						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>
			
						<a-form-item><a-button type="primary" html-type="submit" @click="initGoods">查询</a-button></a-form-item>
					</a-form>
				</div>
			
				<!-- 操作栏 -->
				<div class="handle">
					<a-button type="primary" @click="onNavJump('goodsmanage/add?commodity_type=1')">发布商品</a-button>
					<a-button @click="putawayAll('up')">批量上架</a-button>
					<a-button @click="putawayAll('down')">批量下架</a-button>
					<a-button @click="deletePro('all')">批量删除</a-button>
					<a-button @click="importFile(1)">批量导入</a-button>
					<a-button @click="download">批量导出</a-button>
				</div>
			
				<!-- 表格  :pagination="{pageSize:5,total: total1}"-->
				<div id="tabHeight4" style="flex: 1;">
					<a-table
					    v-if="tabHeight>0"
						:loading="loading"
						:rowSelection="{ selectedRowKeys: selectedRowKeysA, onChange: onSelectChangeA }"
						:columns="columns"
						:dataSource="dataSource"
						:pagination="pagination"
						@change="onChangeload"
						:scroll="{ x: 1700, y: tabHeight }"
					>
						<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
						
						<div slot="product_title" class="proTitleDiv" slot-scope="text" :title="text">
							{{text}}
						</div>
					
						<span slot="status" slot-scope="text">
							<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
							<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
							<a-tag v-else color="#969DA8">待上架</a-tag>
						</span>
					
						<span slot="action" slot-scope="text">
							<div>
								<template v-if="text.status == 2">
									<a
										@click="seeProduct(text.id,text.commodity_type)"
									>详情</a>
									<a-divider type="vertical" />
									<a
										@click="putaway(text.id, 'dowm')"
									>下架</a>
								</template>
								<template v-else>
									<a
										@click="onexits(text.id,text.commodity_type)"
									>编辑</a>
									<a-divider type="vertical" />
									<a
										@click="putaway(text.id, 'up')"
									>上架</a>
								</template>
								
								<a-divider type="vertical" />
								<a
									@click="repertoryAdd(text.id)"
								>添加库存</a>
								<a-divider type="vertical" />
								<a
									@click="deletePro('single', text.id)"
								>删除</a>
							</div>
						</span>
					</a-table>
				</div>
			</a-tab-pane>
			
			<a-tab-pane tab="自选商品" key="2" v-if="commodity_setup[1] && haveZX">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="zxform" @submit="zxhandleSubmit">
						<a-form-item>
							<a-cascader
								v-if="options.length"
								style="width: 195px"
								:fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
								:options="options"
								@change="onChange"
								:displayRender="displayRender"
								changeOnSelect
								:loadData="loadData"
								placeholder="请选择商品分类"
								v-decorator="['cid']"
							/>
							<a-select v-else placeholder="请选择商品分类" style="width: 195px"></a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品品牌" style="width: 195px" v-decorator="['brand_id']">
								<a-select-option v-for="(item, i) in brandlist" :key="i" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品状态" style="width: 195px" v-decorator="['status']">
								<a-select-option v-for="(item, i) in select" :key="i" :value="item.value">{{ item.text }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item><a-input allowClear style="width:300px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-button @click="resetButton('zxform')">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle">
					<a-button type="primary" @click="onNavJump('goodsmanage/optional')">添加商品</a-button>
					<a-button @click="onOptionalBatch">批量删除</a-button>
				</div>

				<!-- 表格 -->
				<div id="tabHeight2" style="flex: 1;">
					<a-table
						v-if="tabHeight>0"
						:loading="loading"
						:rowSelection="{ selectedRowKeys: selectedRowKeysB, onChange: onSelectChangeB }"
						:columns="cloums2"
						:dataSource="dataSource"
						:pagination="pagination"
						@change="onChangeloadsa"
						:scroll="{ x: 1600, y: tabHeight }"
					>
						<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
						
						<div slot="product_title" slot-scope="text" class="proTitleDiv" :title="text">
							{{text}}
						</div>
					
						<span slot="source">总平台</span>
					
						<span slot="action" slot-scope="text">
							<div>
								<a
									@click="onexits(text.id,text.commodity_type)"
								>编辑</a>
								<a-divider type="vertical" />
								<a
									@click="onoPtionalDel(text.id)"
								>删除</a>
							</div>
						</span>
						<span></span>
					</a-table>
				</div>
			</a-tab-pane>

			<a-tab-pane tab="待审核商品" key="3">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="dshform" @submit="dshhandleSubmit">
						<a-form-item>
							<a-cascader
								v-if="options.length"
								style="width: 195px"
								:fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
								:options="options"
								@change="onChange"
								:displayRender="displayRender"
								changeOnSelect
								:loadData="loadData"
								placeholder="请选择商品分类"
								v-decorator="['cid']"
							/>
							<a-select v-else placeholder="请选择商品分类" style="width: 195px"></a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品品牌" style="width: 195px" v-decorator="['brand_id']">
								<a-select-option v-for="(item, i) in brandlist" :key="i" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="请选择商品状态" style="width: 195px" v-decorator="['status']">
								<a-select-option value="1">审核中</a-select-option>
								<!-- <a-select-option value="2">审核通过</a-select-option> -->
								<a-select-option value="3">审核失败</a-select-option>
								<a-select-option value="4">待审核</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item><a-input allowClear style="width:300px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-button @click="resetButton('dshform')">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit">查询</a-button></a-form-item>
					</a-form>
				</div>
				<!-- 操作栏 -->
				<div class="handle">
					<a-button @click="submitAuditAllType">批量撤销</a-button>

					<a-button @click="submitAuditAll">批量提交</a-button>

					<a-button @click="onAuditDelAll">批量删除</a-button>
				</div>

				<!-- 表格 -->
				<div id="tabHeight3" style="flex: 1;">
					<a-table
						v-if="tabHeight>0"
						:loading="loading"
						:rowSelection="{ selectedRowKeys: selectedRowKeysC, onChange: onSelectChangeC }"
						:columns="cloums3"
						:dataSource="dataSource"
						:pagination="pagination3"
						@change="pageCurrentChangeHandle"
						:scroll="{ x: 1600, y: tabHeight }"
					>
						<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
						
						<div slot="product_title" slot-scope="text" class="proTitleDiv" :title="text">
							{{text}}
						</div>
						
						<div slot="commodity_type" slot-scope="text">
							{{text==1?'服务类商品':'实物商品'}}
						</div>
					
						<span slot="status" slot-scope="text">
							<a-tag v-if="text == 1" color="#8BC34A">审核中</a-tag>
							<a-tag v-else-if="text == 2" color="#8BC34A">审核通过</a-tag>
							<a-tag v-else-if="text == 3" color="#969DA8">审核失败</a-tag>
							<a-tag v-else color="#969DA8">待审核</a-tag>
						</span>
					
						<span slot="action" slot-scope="text">
							<div>
								<a
									v-if="text.mch_status != 3"
									@click="submitAudit(text.id, text.mch_status == 1 ? '撤销' : '提交')"
								>{{ text.mch_status == 1 ? '撤销审核' : '提交审核' }}</a>
								<a
									v-else
									@click="seeWhy(text.refuse_reasons)"
								>查看原因</a>
								
								<template v-if="text.mch_status != 1">
									<a-divider type="vertical" />
									<a
										@click="onexits(text.id,text.commodity_type)"
									>编辑</a>
									<a-divider type="vertical" />
									<a
										@click="onAuditDel(text.id)"
									>删除</a>
								</template>
							</div>
						</span>
					</a-table>
				</div>
				
			</a-tab-pane>

			<!--      <a-tab-pane tab="分类标签" key="4">-->
			<!--        &lt;!&ndash; 搜索 &ndash;&gt;-->
			<!--        <div class="search">-->
			<!--          <a-form layout="inline">-->

			<!--            <a-form-item>-->
			<!--              <a-input v-model="searchClassName" allowClear style="width:300px;" placeholder="请输入分类标签名称" />-->
			<!--            </a-form-item>-->

			<!--            <a-form-item>-->
			<!--              <a-button type="primary" html-type="submit" @click="getClassify">-->
			<!--                查询-->
			<!--              </a-button>-->
			<!--            </a-form-item>-->

			<!--          </a-form>-->
			<!--        </div>-->

			<!--        &lt;!&ndash; 操作栏 &ndash;&gt;-->
			<!--        <div class="handle">-->
			<!--          <a-button @click="visibleClass=true">新增分类标签</a-button>-->
			<!--          &lt;!&ndash; <a-divider type="vertical" />-->
			<!--          <a-button>导出</a-button> &ndash;&gt;-->
			<!--        </div>-->

			<!--        &lt;!&ndash; 表格 &ndash;&gt;-->
			<!--        <a-table :columns="columnsClass" :dataSource="dataSource" :pagination="pagination" @change="onChangeClass">-->

			<!--          <span slot="is_display" slot-scope="text,record">-->
			<!--            <a-switch @change="isDisplay(record)" v-model="record.is_display"/>-->
			<!--          </span>-->

			<!--          <span slot="action" slot-scope="text,record">-->
			<!--            <div style="margin-bottom: 6px;">-->
			<!--              <a-button icon="arrow-up" size="small" @click="roofClass(record)">置顶</a-button>-->
			<!--              <a-divider type="vertical" />-->
			<!--              <a-button icon="form" size="small" @click="modifyClass(record.cid)">编辑</a-button>-->
			<!--              <a-divider type="vertical" />-->
			<!--              <a-button icon="delete" size="small" @click="delClass(record)">删除</a-button>-->
			<!--            </div>-->
			<!--          </span>-->

			<!--        </a-table>-->

			<!--      </a-tab-pane>-->
		</a-tabs>

		<!-- 添加库存 -->
		<a-modal title="添加库存" v-model="visibleK" @ok="repertoryOk(false)">
			<a-form :from="forma">
				<a-form-item label="增加库存" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
					<a-input
						type="Number"
						style="width:280px;"
						v-model="repertory"
						v-decorator="['repertory', { rules: [{ required: true, message: 'Please input your note!' }] }]"
					/>
				</a-form-item>

				<a-form-item label="剩余库存" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">{{ repertory_pro.stock }}</a-form-item>
			</a-form>
		</a-modal>

		<a-modal title="添加库存" width="680px" v-model="visibleKK" @ok="repertoryOk(true)">
			<a-table :columns="columnsK" :dataSource="tableData" style="width:100%;max-height: 500px;overflow: auto;">
				<template slot="addStockNum" slot-scope="text, record">
					<a-input type="number" v-model="record.addStockNum" style="width:85px" />
				</template>
			</a-table>
		</a-modal>

		<!-- 新增分类标签 -->
		<a-modal title="新增分类标签" v-model="visibleClass" @ok="setClassOk">
			<a-form :from="formc">
				<a-form-item label="分类标签名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-input
						placeholder="请输入分类标签名称"
						v-model="setClassName"
						v-decorator="['setClassName', { rules: [{ required: true, message: 'Please input your note!' }] }]"
					/>
				</a-form-item>

				<a-form-item label="是否显示" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-radio-group name="radioGroup" v-model="setClassDis">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-item>
			</a-form>
		</a-modal>

		<!-- 编辑分类标签 -->
		<a-modal title="编辑分类标签" v-model="visibleClass1" @ok="modifyClassOk">
			<a-form :from="formc">
				<a-form-item label="分类标签名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-input
						placeholder="请输入分类标签名称"
						v-model="setClassName"
						v-decorator="['setClassName', { rules: [{ required: true, message: 'Please input your note!' }] }]"
					/>
				</a-form-item>

				<a-form-item label="是否显示" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-radio-group name="radioGroup" v-model="setClassDis">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-item>
			</a-form>
		</a-modal>
		<!-- 商品上架选择分类标签 -->
		<a-modal title="选择分类标签" v-model="visibleChoose" @ok="chooseClassOk">
			<a-form :from="formc">
				<a-form-item label="商品分类标签" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-cascader
						v-if="options.length"
						:fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
						:options="options"
						v-model="chooseClass"
						:displayRender="displayRender"
						changeOnSelect
						:loadData="loadData"
						placeholder="请选择商品分类"
					/>
					<a-select v-else placeholder="请选择商品分类"></a-select>
				</a-form-item>
			</a-form>
		</a-modal>

		<div class="reasonMask" v-if="visibleReason">
			<div>
				<div class="reasonMask_title">
					查看原因
					<a-icon type="close" @click="visibleReason = false" />
				</div>
				<div class="reasonMask_content">
					<div class="reasonMask_content_left">失败原因：</div>
					<div class="reasonMask_content_right">{{ refuse_reasons }}</div>
				</div>
				<div class="reasonMask_bottom"><div @click="visibleReason = false">确定</div></div>
			</div>
		</div>

		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>

				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>

				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '商品编号',
		key: 'id',
		dataIndex: 'id',
		width: 100,
		fixed: 'left',
	},
	{
		title: '商品图片',
		key: 'imgurl',
		scopedSlots: { customRender: 'imgurl' },
		width: 95
	},
	{
		title: '商品标题',
		key: 'product_title',
		dataIndex: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: 220
	},
	{
		title: '商品分类',
		key: 'pname',
		dataIndex: 'pname',
		width: 150
	},
	{
		title: '品牌',
		key: 'brand_name',
		dataIndex: 'brand_name',
		width: 150
	},
	{
		title: '价格',
		key: 'price',
		dataIndex: 'price',
		width: 120
	},
	{
		title: '库存',
		key: 'num',
		dataIndex: 'num',
		width: 120
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
	},
	{
		title: '销量',
		key: 'volume',
		dataIndex: 'volume',
		width: 120
	},
	{
		title: '上架时间',
		key: 'upper_shelf_time',
		dataIndex: 'upper_shelf_time',
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 230,
		fixed: 'right',
	}
];

const cloums2 = [
	{
		title: '商品编号',
		key: 'id',
		dataIndex: 'id',
		width: 100,
		fixed: 'left',
	},
	{
		title: '商品图片',
		key: 'imgurl',
		scopedSlots: { customRender: 'imgurl' },
		width: 95
	},
	{
		title: '商品标题',
		key: 'product_title',
		dataIndex: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: 220
	},
	{
		title: '商品分类',
		key: 'pname',
		dataIndex: 'pname',
		width: 150
	},
	{
		title: '品牌',
		key: 'brand_name',
		dataIndex: 'brand_name',
		width: 150
	},
	{
		title: '价格',
		key: 'price',
		dataIndex: 'price',
		width: 120
	},
	{
		title: '库存',
		key: 'num',
		dataIndex: 'num',
		width: 120
	},
	{
		title: '商品来源',
		key: 'source',
		scopedSlots: { customRender: 'source' },
	},
	// {
	//   title:'分类标签',
	//   key: 'shopkeepers_classification',
	//   dataIndex: 'shopkeepers_classification'
	// },
	{
		title: '销量',
		key: 'volume',
		dataIndex: 'volume',
		width: 120
	},
	{
		title: '添加时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 120,
		fixed: 'right',
	}
];

const cloums3 = [
	{
		title: '商品编号',
		key: 'id',
		dataIndex: 'id',
		width: 100,
		fixed: 'left',
	},
	{
		title: '商品图片',
		key: 'imgurl',
		scopedSlots: { customRender: 'imgurl' },
		width: 95
	},
	{
		title: '商品标题',
		key: 'product_title',
		dataIndex: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: 220
	},
	{
		title: '分类',
		key: 'pname',
		dataIndex: 'pname',
		width: 150
	},
	{
		title: '品牌',
		key: 'brand_name',
		dataIndex: 'brand_name',
		width: 150
	},
	{
		title: '商品类型',
		key: 'commodity_type',
		dataIndex: 'commodity_type',
		scopedSlots: { customRender: 'commodity_type' },
		width: 150
	},
	{
		title: '价格',
		key: 'price',
		dataIndex: 'price',
		width: 120
	},
	{
		title: '库存',
		key: 'num',
		dataIndex: 'num',
	},
	{
		title: '商品状态',
		key: 'mch_status',
		dataIndex: 'mch_status',
		scopedSlots: { customRender: 'status' },
		width: 100
	},
	{
		title: '销量',
		key: 'volume',
		dataIndex: 'volume',
		width: 120
	},
	{
		title: '添加时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 180,
		fixed: 'right',
	}
];

const columnsClass = [
	{
		title: 'ID',
		key: 'cid',
		dataIndex: 'cid'
	},
	{
		title: '分类标签名称',
		key: 'pname',
		dataIndex: 'pname'
	},
	{
		title: '是否显示',
		key: 'is_display',
		dataIndex: 'is_display',
		scopedSlots: { customRender: 'is_display' }
	},
	{
		title: '添加时间',
		key: 'add_date',
		dataIndex: 'add_date'
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' }
	}
];

const columnsK = [
	{
		title: '剩余库存',
		dataIndex: 'stock',
		key: 'stock',
		align: 'center'
	},
	{
		title: '库存预警',
		dataIndex: 'stockWarn',
		key: 'stockWarn',
		align: 'center'
	},
	{
		title: '增加库存',
		dataIndex: 'addStockNum',
		key: 'addStockNum',
		align: 'center',
		scopedSlots: { customRender: 'addStockNum' }
	}
];

export default {
	data() {
		return {
			activeKey: '1', //tabs默认选中的
			loading: true,
			columns,
			cloums2,
			cloums3,
			columnsClass,
			columnsK,
			dataSource: [],
			visible: false,
			form: this.$form.createForm(this, { name: 'form_in_modal' }),
			forma: this.$form.createForm(this, { name: 'forma' }),
			zxform: this.$form.createForm(this, { name: 'zxform' }),
			formc: this.$form.createForm(this, { name: 'formc' }),
			dshform: this.$form.createForm(this, { name: 'dshform' }),
			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 12 }
			},
			confirmLoading: false,
			selectedRowKeysA: [],
			selectedRowA: [],
			selectedRowKeysB: [],
			selectedRowB: [],
			selectedRowKeysC: [],
			selectedRowC: [],
			select: [],
			options: [],
			brandlist: [],
			repertory: '', // 新增的库存
			visibleK: false,
			visibleKK: false,
			repertory_pro: '',
			repertory_pid: '',
			tableData: [],
			brand_id1: undefined,
			product_title1: '',
			cid1: undefined,
			status1: undefined,
			pagination: {},
			pagination3: {},
			visibleClass: false,
			visibleClass1: false,
			searchClassName: '',
			setClassName: '',
			setClassDis: 1,
			visibleChoose: false,
			chooseClass: '',
			chooseId: '',
			cache: {},
			pagesize3: 10,
			total3: '',
			total1: '',

			visibleReason: false,
			refuse_reasons: '',

			commodity_setup: [true, true],

			urls: '',
			visible1: false,
			searchData: {},
			
			tabHeight: 0,
			haveZX: true
		};
	},
	mounted() {
		if (this.$route.query.tab) {
			this.handCut(this.$route.query.tab);
		} else {
			this.initGoods();
		}
		
		this.getCommodityClass();
		
		this.$nextTick(()=>{
			if(this.tabHeight == 0){
				if(document.getElementById('tabHeight1')){
					this.tabHeight = document.getElementById('tabHeight1').clientHeight-120
				}else if(document.getElementById('tabHeight2')){
					this.tabHeight = document.getElementById('tabHeight2').clientHeight-120
				}else if(document.getElementById('tabHeight3')){
					this.tabHeight = document.getElementById('tabHeight3').clientHeight-120
				}else if(document.getElementById('tabHeight4')){
					this.tabHeight = document.getElementById('tabHeight4').clientHeight-120
				}
				
				if(this.tabHeight<=0){
					this.tabHeight = 300
				}
			}
		})
		
		setTimeout(()=>{
			let url = location.href.split('?');
			window.history.pushState({}, '', url[0]);
		},10)
	},
	methods: {
		onConfig() {
			this.$router.push({
				path: "goodsmanage/config"
			});
		},
		getTableHeight(){
			if(this.activeKey == 1){
				this.tabHeight = document.getElementById('tabHeight1').clientHeight-120
			}else if(this.activeKey == 2){
				this.tabHeight = document.getElementById('tabHeight2').clientHeight-120
			}else if(this.activeKey == 3){
				this.tabHeight = document.getElementById('tabHeight3').clientHeight-120
			}else if(this.activeKey == 4){
				this.tabHeight = document.getElementById('tabHeight4').clientHeight-120
			}
			
			if(this.tabHeight<=0){
				this.tabHeight = 300
			}
		},
		//导入
		importFile(commodity_type){
			this.$router.push({ path: "goodsmanage/import?commodity_type="+commodity_type});
		},
		// 导出属性
		exportAttr(){
			this.urls = '?module=pc_api&action=product&m=batch_export&pageto=';
			this.visible1 = !this.visible1;
		},
		/**
		 * @name 导出
		 * */

		download() {
			this.urls = '?module=pc_api&action=product&app=Index&pageto=';
			this.visible1 = !this.visible1;
		},
		/**
		 * @name 导出
		 */
		onDownload(pageto) {
			this.$request.download(this.urls + pageto, this.searchData);
		},
		pageCurrentChangeHandle(pages) {
			this.pagination3 = {
				pagesize: pages.pageSize,
				page: pages.current,
				current: pages.current,
				total: pages.total
			};
			let data = {
				pagesize: pages.pageSize,
				page: pages.current
			};
			this.getAuthstr(data);
		},
		submitAuditAllType() {
			let { selectedRowC } = this;
			let result, data, isStatus;

			if (!selectedRowC.length) {
				this.$message.warning('请选择需撤销审核的商品！');
				return;
			}

			isStatus = selectedRowC.some(item => item.mch_status != 1);
			if (isStatus) {
				this.$message.warning('存在未提交审核商品！');
				return;
			}

			result = Array.from(selectedRowC, item => item.id);

			data = {
				p_id: result.join(',')
			};

			this.$confirm({
				title: '确定撤销审核商品吗?',
				onOk: () => {
					this.httpSubmit(data);
				}
			});
		},
		submitAuditAll() {
			let { selectedRowC } = this;
			let result, data, isStatus;

			if (!selectedRowC.length) {
				this.$message.warning('请选择需提交审核的商品！');
				return;
			}

			isStatus = selectedRowC.some(item => item.mch_status == 1);
			if (isStatus) {
				this.$message.warning('存在审核中商品！');
				return;
			}

			result = Array.from(selectedRowC, item => item.id);

			data = {
				p_id: result.join(',')
			};

			this.$confirm({
				title: '确定提交审核商品吗?',
				onOk: () => {
					this.httpSubmit(data);
				}
			});
		},
		submitAudit(id, centent) {
			this.$confirm({
				title: `确定${centent}商品审核吗?`,
				onOk: () => {
					this.httpSubmit({ p_id: id });
				}
			});
		},
		httpSubmit(data) {
			this.$request.get('?module=pc_api&action=product&app=submit_audit', { params: data }).then(res => {
				let { code, message } = res;

				if (code === 200) {
					this.selectedRowKeysC = [];
					this.$message.success(message);
					this.getAuthstr(this.pagination3);
				} else {
					this.$message.warning(message);
				}
			});
		},
		seeWhy(refuse_reasons) {
			this.refuse_reasons = refuse_reasons;
			this.visibleReason = true;
		},
		onexits(id,commodity_type) {
			this.$router.push({ path: 'goodsmanage/edits/' + id + '?tab=' + this.activeKey +'&commodity_type='+commodity_type });
		},
		resetButton(name) {
			this[name].resetFields();
			this.brandlist = [];
		},
		dshhandleSubmit(e) {
			e.preventDefault();

			this.dshform.validateFields((err, values) => {
				if (!err) {
					let { cid, brand_id, status, product_title } = values;

					let sid = undefined;

					if (cid && cid.length) {
						sid = JSON.parse(JSON.stringify(cid));
						sid = sid.pop();
					}

					let data = {
						cid: sid,
						brand_id,
						status,
						product_title
					};

					this.getAuthstr(data);
				}
			});
		},
		zxhandleSubmit(e) {
			e.preventDefault();
			this.zxform.validateFields((err, values) => {
				if (!err) {
					let { cid, brand_id, status, product_title } = values;

					let sid = undefined;
					if (cid && cid.length) {
						sid = JSON.parse(JSON.stringify(cid));
						sid = sid.pop();
					}

					let data = {
						cid: sid,
						brand_id,
						status,
						product_title
					};

					this.getOptional(data);
				}
			});
		},
		// 添加库存
		repertoryAdd(p_id) {
			this.repertory_pid = p_id;

			this.$request.get('?module=pc_api&action=product&app=up_stock_page&p_id=' + p_id).then(res => {
				if (res.code == 200) {
					if (res.attr.length == 0) {
						this.repertory_pro = res.attrList[0];
						this.visibleK = true;
					} else {
						let tableData = [];
						res.attrList.filter(item => {
							tableData.push({
								addStockNum: '',
								stock: item[0].stock,
								stockWarn: item[0].stockWarn
							});
							item.filter(items => {
								tableData[tableData.length - 1][items.name] = items.value.length > 10 ? items.value.substr(0, 10) + '...' : items.value;
							});
						});

						var column = [];
						res.attr.filter(item => {
							var name = item.attrName[0];
							column.push({
								title: name.length > 10 ? name.substr(0, 10) + '...' : name,
								dataIndex: name,
								key: name,
								align: 'center'
							});
						});
						column.push(...columnsK);
						this.columnsK = column;
						this.tableData = tableData;

						this.visibleKK = true;
					}
				}
			});
		},
		repertoryOk(flag) {
			let data;
			let p_id = this.repertory_pid;
			if (flag) {
				let isNumber = this.tableData.some(item => {
					return item.addStockNum && Number.parseInt(item.addStockNum) != item.addStockNum;
				});
				if (isNumber) {
					this.$message.warning('请填写整数库存！');
					return;
				}

				let isHaveNum = this.tableData.some(item => {
					return item.addStockNum;
				});

				if (!isHaveNum) {
					this.$message.warning('请填写新增库存量！');
					return;
				}

				let number = '';
				this.tableData.filter(item => {
					if (number) {
						number += ',';
					}
					number += item.addStockNum ? item.addStockNum : '0';
				});
				data = {
					p_id,
					number
				};
			} else {
				if (!this.repertory) {
					this.$message.warning('请填写新增库存量！');
					return;
				}

				if (Number.parseInt(this.repertory) != this.repertory) {
					this.$message.warning('请填写整数库存！');
					return;
				}

				data = {
					p_id,
					number: this.repertory
				};
			}

			this.$request.post('?module=pc_api&action=product&app=up_stock', data).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.visibleK = false;
					this.visibleKK = false;
					this.repertory = '';
					this.initGoods();
				} else {
					this.$message.warning(res.message);
				}
			});
		},
		onChangeload(pagination) {
			this.initGoods({ page: pagination.current, pagesize: pagination.pageSize });
		},
		onChangeloadsa(pagination) {
			this.getOptional({}, { page: pagination.current, pagesize: pagination.pageSize });
		},
		onChange(value) {
			if (!value.length) {
				this.brandlist = [];
				this.brand_id = undefined;
			}

			this.brandlist = this.cache[value[value.length - 1]];
		},
		loadData(selectedOptions) {
			const targetOption = selectedOptions[selectedOptions.length - 1];
			targetOption.loading = true;

			function callback(list) {
				let { class_list, brand_list, class_id } = list;

				if (class_id) {
					targetOption.isLeaf = true;
					targetOption.loading = false;
				}

				targetOption.loading = false;

				if (class_list.length) {
					let result = Array.from(class_list[0], item => {
						item.isLeaf = false;
						return item;
					});

					targetOption.children = [...result];
				}

				this.cache[targetOption.cid] = brand_list;

				Object.assign(this, {
					options: [...this.options],
					brandlist: brand_list
				});
			}

			this.loadClass({ cid: targetOption.cid }, callback);
		},
		displayRender({ labels }) {
			return labels[labels.length - 1];
		},
		seeProduct(id,commodity_type) {
			this.onNavJump('goodsmanage/show?id=' + id + '&key=' + this.activeKey+'&commodity_type='+commodity_type);
		},
		/**
		 * @name 重置商品列表搜索
		 */
		resetGoods() {
			this.brand_id1 = undefined;
			this.product_title1 = '';
			this.cid1 = undefined;
			this.status1 = undefined;
			this.brandlist = [];
		},
		/**
		 * @name 商品列表
		 */
		initGoods(page = {}, current = 1) {
			this.loading = true;
			let cid = '';
			if (this.cid1 && this.cid1.length > 0) {
				cid = this.cid1[this.cid1.length - 1];
			}

			let data = {
				commodity_type: this.activeKey == 1?0:1,
				cid,
				brand_id: this.brand_id1,
				status: this.status1,
				product_title: this.product_title1,
				...page
			};
			
			this.searchData = data
			
			let url = '?module=pc_api&action=product&app=Index';
			if (this.activeKey == 3) {
				this.getAuthstr();
				return;
			}

			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;

				this.getTableHeight();
				if (code === 200) {
					this.haveZX = data.zx;
					let pages = {
						total: data.total,
						current: page.page || current
					};

					this.selectedRowKeysA = [];

					let commodity_setup = [false, false];

					if (data.commodity_setup && data.commodity_setup.length > 0) {
						data.commodity_setup.filter(item => {
							if (item == 1) {
								commodity_setup[0] = true;
							} else if (item == 2) {
								commodity_setup[1] = true;
							}
						});
					}

					if (!commodity_setup[0] && commodity_setup[1]) {
						this.handCut('2');
					} else if (!commodity_setup[0] && !commodity_setup[1]) {
						this.handCut('3');
					}

					Object.assign(this, {
						dataSource: data.list,
						select: data.select,
						pagination: pages,
						commodity_setup: commodity_setup
					});

					setTimeout(() => {
						this.loading = false;
					}, 800);
				} else {
					this.$message.error(message);

					setTimeout(() => {
						this.loading = false;
					}, 800);
				}
			});
		},
		/**
		 * @name 路由跳转
		 */
		onNavJump(url) {
			this.$router.push(url);
		},
		/**
		 * @name 操作分割线
		 * */

		isDividerShow(i, list) {
			i += 1;
			if (list.length) {
				return i != list.length;
			}
		},
		/**
		 * @name 商品分类
		 */
		getCommodityClass(data = { class_str: 0, brand_str: '' }) {
			this.$request.get('?module=pc_api&action=product&app=get_class', { params: data }).then(res => {
				let { code, message, list } = res;
				if (code === 200) {
					if (list.class_list.length) {
						let result = Array.from(list.class_list[0], item => {
							item.isLeaf = false;
							return item;
						});

						if (data.class_str == 0) {
							list.brand_list = [];
						}

						Object.assign(this, {
							brandlist: list.brand_list,
							options: result
						});
					}
				} else {
					this.$message.error(message);
				}
			});
		},
		/**
		 * @name 分类加载
		 * */

		loadClass(data = { cid: 1, brand_str: '' }, callback) {
			this.$request.get('?module=pc_api&action=product&app=choice_class', { params: data }).then(res => {
				let { code, message, list } = res;
				if (code === 200) {
					callback.call(this, list);
				} else {
					this.$message.error(message);
				}
			});
		},
		handleOk() {
			this.confirmLoading = true;
			setTimeout(() => {
				this.visible = false;
				this.confirmLoading = false;
			}, 2000);
		},
		onSelectChangeA(selectedRowKeys, selectedRow) {
			this.selectedRowKeysA = selectedRowKeys;
			this.selectedRowA = selectedRow;
		},
		onSelectChangeB(selectedRowKeys, selectedRowB) {
			Object.assign(this, {
				selectedRowKeysB: selectedRowKeys,
				selectedRowB: selectedRowB
			});
		},
		onSelectChangeC(selectedRowKeys, selectedRow) {
			this.selectedRowKeysC = selectedRowKeys;
			this.selectedRowC = selectedRow;
		},
		handCut(key) {
			this.activeKey = key + '';
			this.dataSource = [];
			let arr = ['initGoods', 'getOptional', 'getAuthstr', 'initGoods'];
			// let arr = ['initGoods','getOptional','initGoods','getClassify']
			this[arr[key - 1]]();
			console.log(111, key, this.activeKey);
			
			setTimeout(()=>{
				if(this.tabHeight == 0){
					if(document.getElementById('tabHeight1')){
						this.tabHeight = document.getElementById('tabHeight1').clientHeight-120
					}else if(document.getElementById('tabHeight2')){
						this.tabHeight = document.getElementById('tabHeight2').clientHeight-120
					}else if(document.getElementById('tabHeight3')){
						this.tabHeight = document.getElementById('tabHeight3').clientHeight-120
					}else if(document.getElementById('tabHeight4')){
						this.tabHeight = document.getElementById('tabHeight4').clientHeight-120
					}
					
					console.log(this.tabHeight)
				}
				
			},0)
		},
		/**
		 * @name 分类标签
		 * */

		getClassify(page = {}, current = 1) {
			let data = {
				pname: this.searchClassName,
				...page
			};
			this.$request.post('?module=pc_api&action=product&app=class_list', data).then(res => {
				let { code, message, data } = res;
				if (code === 200) {
					let pages = {
						total: data.total,
						current: page.page || current
					};

					Object.assign(this, {
						dataSource: data.list,
						select: data.select,
						pagination: pages
					});
				} else {
					this.$message.error(message);
				}
			});
		},
		onChangeClass(pagination) {
			this.getClassify({ page: pagination.current, ...pagination });
		},
		isDisplay(record) {
			let data = {
				cid: record.cid,
				is_display: record.is_display ? 1 : 0
			};
			this.$request.post('?module=pc_api&action=product&app=is_display', data).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
				} else {
					this.$message.error(res.message);
					this.getClassify();
				}
			});
		},
		// 添加分类标签
		setClassOk() {
			this.$request.post('?module=pc_api&action=product&app=add_class&pname=' + this.setClassName + '&is_display=' + this.setClassDis).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.visibleClass = false;
					this.setClassName = '';
					this.setClassDis = 1;
					this.getClassify();
				} else {
					this.$message.error(res.message);
				}
			});
		},
		modifyClass(id) {
			this.$request.get('?module=pc_api&action=product&app=edit_class_page&id=' + id).then(res => {
				if (res.code == 200) {
					this.setClassName = res.data.pname;
					this.setClassDis = res.data.is_display ? 1 : 0;
					this.modifyClassId = id;
					this.visibleClass1 = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		modifyClassOk() {
			let data = {
				id: this.modifyClassId,
				is_display: this.setClassDis,
				pname: this.setClassName
			};
			this.$request.post('?module=pc_api&action=product&app=edit_class', data).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.visibleClass1 = false;
					this.setClassName = '';
					this.setClassDis = 1;
					this.getClassify();
				} else {
					this.$message.error(res.message);
				}
			});
		},
		// 置顶分类标签
		roofClass(record) {
			this.$request.post('?module=pc_api&action=product&app=roof_class&id=' + record.cid).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.getClassify();
				} else {
					this.$message.error(res.message);
				}
			});
		},
		delClass(record) {
			this.$request.post('?module=pc_api&action=product&app=del_class&id=' + record.cid).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.getClassify();
				} else {
					this.$message.error(res.message);
				}
			});
		},
		getOptional(datas = {}, page = {}, current = 1) {
			this.loading = true;

			let data = {
				...datas,
				...page
			};

			this.$request.post('?module=pc_api&action=product&app=optional_list', data).then(res => {
				let { code, message, data } = res;
				this.getTableHeight();
				if (code === 200) {
					let pages = {
						total: data.total,
						current: page.page || current
					};

					this.selectedRowKeysB = [];

					Object.assign(this, {
						dataSource: data.list,
						select: data.select,
						loading: false,
						pagination: pages
					});
				} else {
					this.$message.error(message);
				}
			});
		},
		getAuthstr(datas = {}) {
			this.loading = true;
			this.$request.post('?module=pc_api&action=product&app=examine_list', datas).then(res => {
				this.getTableHeight();
				let { code, message, data } = res;
				if (code === 200) {
					Object.assign(this, {
						dataSource: data.list,
						select: data.select,
						pagination3: {
							pageSize: datas.pagesize ? datas.pagesize : 10,
							page: datas.page ? datas.page : 1,
							current: datas.page ? datas.page : 1,
							total: data.total
						}
					});

					setTimeout(() => {
						this.loading = false;
					}, 800);
				} else {
					this.$message.error(message);
				}
			});
		},
		deletePro(type, id) {
			let context = '确定要删除此项商品吗?';
			if (type == 'all') {
				if (this.selectedRowA.length == 0) {
					this.$message.warning('请选择商品！');
					return;
				}

				let result = Array.from(this.selectedRowA, item => item.id);
				id = result.join(',');

				context = '确定要删除所选商品吗?';
			}

			this.$confirm({
				title: '提示',
				content: context,
				onOk: () => {
					let data = { id };
					this.$request.post('?module=pc_api&action=product&app=del', data).then(res => {
						if (res.code == 200) {
							this.selectedRowA = [];
							this.selectedRowKeysA = [];
							this.$message.success(res.message);
							this.initGoods();
						} else {
							this.$message.warning(res.message);
						}
					});
				}
			});
		},
		// 上架下架
		putaway(id, type) {
			let text = type == 'up' ? '上架' : '下架';
			this.$confirm({
				title: `确定${text}此商品吗?`,
				onOk: () => {
					if (type == 'up') {
						this.chooseId = id;
						this.chooseClassOk();
						// this.visibleChoose = true
					} else {
						let data = { id };
						this.$request.post('?module=pc_api&action=product&app=upper_lower_frames', data).then(res => {
							if (res.code == 200) {
								this.$message.success(res.message);
								this.initGoods();
							} else {
								this.$message.warning(res.message);
							}
						});
					}
				}
			});
		},
		chooseClassOk() {
			let id = this.chooseId;
			let cid = this.chooseClass[this.chooseClass.length - 1];
			let data = { id, cid };
			this.$request.post('?module=pc_api&action=product&app=upper_lower_frames', data).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.visibleChoose = false;
					this.chooseClass = '';
					this.chooseId = '';
					this.selectedRowA = [];
					this.initGoods();
				} else {
					this.$message.warning(res.message);
				}
			});
		},
		// 批量上架
		putawayAll(type) {
			if (this.selectedRowA.length == 0) {
				this.$message.warning('请选择商品！');
				return;
			}

			if (type == 'up') {
				let flag = this.selectedRowA.every(item => {
					return item.status != 2;
				});

				if (!flag) {
					this.$message.warning('存在上架商品！');
					return;
				}
				let result = Array.from(this.selectedRowA, item => item.id);
				this.chooseId = result.join(',');

				this.$confirm({
					title: `确定上架选中商品吗?`,
					onOk: () => {
						this.selectedRowKeysA = [];
						this.selectedRowA = [];
						this.chooseClassOk();
					}
				});

				// this.visibleChoose = true
			} else {
				let flag = this.selectedRowA.every(item => {
					return item.status == 2;
				});
				if (!flag) {
					this.$message.warning('请确认所选商品都为上架商品！');
					return;
				}
				let result = Array.from(this.selectedRowA, item => item.id);
				let id = result.join(',');
				let data = { id };
				this.$request.post('?module=pc_api&action=product&app=upper_lower_frames', data).then(res => {
					if (res.code == 200) {
						this.$message.success(res.message);
						this.selectedRowKeysA = [];
						this.selectedRowA = [];
						this.initGoods();
					} else {
						this.$message.warning(res.message);
					}
				});
			}
		},
		onoPtionalDel(id) {
			let data = {
				id
			};

			this.$confirm({
				title: '确定要删除此项自选商品吗?',
				onOk: () => {
					this.httpdels(data, this.getOptional);
				}
			});

			let flag = this.selectedRowA.every(item => {
				return item.status != 2;
			});
			if (!flag) {
				this.$message.warning('存在上架商品！');
				return;
			}

			let result = Array.from(this.selectedRowA, item => item.id);
			this.chooseId = result.join(',');

			this.visibleChoose = true;
		},
		onoPtionalDel(id) {
			let data = {
				id
			};

			this.$confirm({
				title: '确定要删除此项自选商品吗?',
				onOk: () => {
					this.httpdels(data, this.getOptional);
				}
			});
		},
		onOptionalBatch() {
			let { selectedRowB } = this;
			let result, data;

			if (!selectedRowB.length) {
				this.$message.warning('请选择需删除的商品！');
				return;
			}

			result = Array.from(selectedRowB, item => item.id);

			data = {
				id: result.join(',')
			};

			this.$confirm({
				title: '确定要删除所选自选商品吗?',
				onOk: () => {
					this.selectedRowB = [];
					this.selectedRowKeysB = [];
					this.httpdels(data, this.getOptional);
				}
			});
		},
		onAuditDel(id) {
			let data = {
				id
			};

			this.$confirm({
				title: '确定要删除此项商品吗?',
				onOk: () => {
					this.httpdels(data, this.getAuthstr);
				}
			});
		},
		onAuditDelAll() {
			let { selectedRowC } = this;
			let result, data, isStatus;

			if (!selectedRowC.length) {
				this.$message.warning('请选择需删除的商品！');
				return;
			}

			isStatus = selectedRowC.some(item => item.mch_status == 1);
			if (isStatus) {
				this.$message.warning('存在审核中商品！');
				return;
			}

			result = Array.from(selectedRowC, item => item.id);

			data = {
				id: result.join(',')
			};

			this.$confirm({
				title: '确定要删除选中商品吗?',
				onOk: () => {
					this.selectedRowC = [];
					this.selectedRowKeysC = [];
					this.httpdels(data, this.getAuthstr);
				}
			});
		},
		httpdels(data, callback) {
			this.$request.post('?module=pc_api&action=product&app=del', data).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.selectedRowKeysB = [];
					this.selectedRowKeysC = [];
					callback();
				} else {
					this.$message.warning(res.message);
				}
			});
		}
	}
};
</script>
<style lang="less">
	.derive {
		height: 200px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		> div {
			width: 100px;
			height: 100px;
			border: 1px solid #03a2f4;
			border-radius: 4px;
			color: #03a2f4;
			font-size: 14px;
			transition: background-color 0.5s;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-evenly;
			cursor: pointer;
		}
	
		> div:hover {
			border: 0px solid #03a2f4;
			color: #ffffff;
			background: #2890ff;
		}
	}
.fund_manage {
	height: 100%;
	.freight{
		margin-right: 15px;
	}
	
	.proTitleDiv{
		max-width: 186px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.ant-tabs{
		display: flex;
		flex-direction: column;
		height: 100%;
		
		.ant-tabs-content{
			flex: 1;
		}
		
		.ant-tabs-top-content > .ant-tabs-tabpane, .ant-tabs-bottom-content > .ant-tabs-tabpane{
			display: flex;
			flex-direction: column;
		}
	}
	
	.search{
		padding: 0 20px;
		.ant-form-inline .ant-form-item{
			margin-right: 8px;
		}
		.ant-btn-primary[class]{
			background-color: #323544;
			border-color: #323544;
		}
		.ant-btn-primary[class]:hover, .ant-btn-primary[class]:focus{
			opacity: 0.8;
		}
	}

	.handle {
		padding: 16px 20px 20px!important;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
		
		.ant-btn{
			margin-right: 8px;
		}
	}
	.difference {
		margin-right: 20px;
		.balance {
			font-size: 16px;
			color: #1e202c;
			margin-right: 20px;

			span {
				color: #03a2f4;
			}
		}
	}

	.table-imgurl {
		width: 60px;
		height: 60px;
	}
}

.reasonMask {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9999;

	> div {
		width: 460px;
		height: 278px;
		background: #ffffff;
		border-radius: 4px;

		.reasonMask_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;
			padding: 0 20px;
			box-sizing: border-box;
			border-bottom: 2px solid #e9ebef;
			font-size: 16px;
			font-weight: bold;
			color: #1e202c;
		}

		.reasonMask_content {
			display: flex;
			height: 149px;
			padding: 40px;
			font-size: 14px;
			color: #323543;

			&_left {
				width: 70px;
			}

			&_right {
				flex: 1;
				overflow: hidden auto;
			}
		}

		.reasonMask_bottom {
			height: 69px;
			border-top: 1px solid #e9ebef;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;

			div {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 112px;
				height: 36px;
				background: #03a1f3;
				border-radius: 2px;
				color: #ffffff;
				cursor: pointer;
			}
		}
	}
}
</style>
